export default __webpack_public_path__ + "static/media/SOC.fab448ec.png";